import { render } from "./ReportStatus.vue?vue&type=template&id=8f9bfccc&scoped=true"
import script from "./ReportStatus.vue?vue&type=script&lang=ts"
export * from "./ReportStatus.vue?vue&type=script&lang=ts"

import "./ReportStatus.vue?vue&type=style&index=0&id=8f9bfccc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8f9bfccc"

export default script